import './App.css'

import { useEffect, useState } from 'react'

import { LoadingView } from '@/components/Loading'

function App() {
  type Message = {
    content: string
    visualType: string
    instruction: string
  }
  const [data, setData] = useState('')
  const [message, setMessage] = useState<Message | null>(null)
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    if (message !== null) {
      const fetchData = async () => {
        try {
          console.log('Request data from extension:', message)
          setLoading(true)
          if (!message.content || message.content.trim() === '') {
            console.error('Invalid message:', message)
            return
          }

          const response = await fetch('https://api.bobai.me', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Authorization: 'Bearer 0nU5tgAA',
            },
            body: JSON.stringify({
              content: message.content,
              visualType: message.visualType,
              instruction: message.instruction,
            }),
          })
          const result = await response.text()
          const htmlContent = decodeURIComponent(
            Array.prototype.map
              .call(atob(result), function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
              })
              .join(''),
          )
          console.log('Success:', htmlContent)
          setData(htmlContent)
        } catch (error) {
          console.error('Error fetching data:', error)
        } finally {
          setLoading(false)
        }
      }

      fetchData()
    }
  }, [message])

  useEffect(() => {
    if (data) {
      const iframe = document.getElementById('artifact') as HTMLIFrameElement
      iframe.srcdoc = data
    }
  }, [data])

  // Add the message event listener
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      console.log('Message:', event.data)
      if (event.data.type == 'FROM_BOBAI') {
        setMessage(event.data)
        //window.removeEventListener('message', handleMessage);
      }
    }
    window.addEventListener('message', handleMessage)

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage)
    }
  }, [])

  return (
    <>
      <div className="title" id="titleDisplay"></div>
      <div className="content" id="contentDisplay"></div>
      <div className="iframe-container">
        {loading ? <LoadingView /> : <iframe id="artifact" sandbox="allow-scripts allow-same-origin"></iframe>}
      </div>
    </>
  )
}

export default App
